<script lang="ts">
  import { onDestroy, onMount } from 'svelte'

  import strings from './loading-strings'

  import styles from '#css/common.pcss.json'

  export let className: string = null;
  export let string: string = null;

  const getRandomString = () => {
    const key = Math.floor(Math.random() * strings.length)
    return strings[key]
  }

  let text = getRandomString()
  let interval: number = null
  let classNames = [styles['loading']]

  onMount(() => {
    if (!string) {
      interval = window.setInterval(() => {
        text = getRandomString()
      }, 3000)
    }
  })

  onDestroy(() => {
    window.clearInterval(interval)
  })

  if (className) {
    classNames.push(className)
  }
</script>

<div class={classNames.join(' ')} style="overflow-anchor: none">
  <svg viewBox='0 0 40 40' style='width: 40px; height: 40px;'>
    <circle cx='20' cy='20' r='18' stroke='var(--green)' stroke-width='2' stroke-dasharray='84 29' fill='none'/>
  </svg>
  {#if string !== ''}
    <span>{string || text}</span>
  {/if}
</div>
